import * as z from 'zod';

export const YearlyLimitSchema = z.object({
  year: z.number().int().min(2000).max(2100),
  limit: z.number().positive({
    message: 'Limit must be greater than 0',
  }),
});

export const UpdateYearlyLimitSchema = z.object({
  year: z.number().int().min(2000).max(2100),
  limit: z.number().positive({
    message: 'Limit must be greater than 0',
  }),
});
